<template>
  <div class="layout-box">
    <div class="layout-header">
      <div class="center_box">
        <div class="header-left">
          <img src="~@/images/logo.png" alt="" class="logo" />
          <div class="nav-box">
            <!-- <div
              :class="['nav-item', activeNav == 'train' ? 'active' : '']"
              @click="clickNavItem('train')"
            >
              集中培训
            </div> -->
            <div
              :class="['nav-item', activeNav == 'home' ? 'active' : '']"
              @click="clickNavItem('home')"
            >
              线上培训
            </div>
            <div
              :class="['nav-item', activeNav == 'exam' ? 'active' : '']"
              @click="clickNavItem('exam')"
            >
              考试
            </div>
          </div>
        </div>
        <div class="header-right">
          <template v-if="has_login">
            <img :src="avatar" alt="" class="avatar" />
          </template>
          <template v-else>
            <div class="login-btn" @click="showLoginDialog">登录</div>
          </template>
        </div>
      </div>
    </div>
    <div class="body-main">
      <div class="center_box">
        <router-view :key="key" />
      </div>
    </div>
    <div class="layout-footer">
      <div class="center_box">
        <div class="footer-item">电话：010-68805886</div>
        <div class="spilt">|</div>
        <div class="footer-item">京ICP 备 05067313号-1</div>
        <div class="spilt">|</div>
        <div class="footer-item">
          文保网安备案号：1101010023 京卫网审字【2014】第39号
        </div>
        <div class="spilt">|</div>
        <div class="footer-item">Copyright 2017 All Rights Reserved.</div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogLogin" width="540px">
      <div class="login_box">
        <div class="login_box-title">登录</div>
        <div class="login_box-wrap">
          <div class="login_box-line">
            <el-input
              placeholder="请输入手机号"
              v-model="loginForm.mobile"
            ></el-input>
          </div>
          <div class="login_box-line">
            <el-input
              type="password"
              placeholder="请输入密码"
              v-model="loginForm.password"
            ></el-input>
          </div>
          <div class="login_box-forget" @click="showForgetDialog">
            忘记密码？
          </div>
          <el-button
            style="margin:24px 0 0;width:100%;"
            type="primary"
            @click="clickLoginBtn"
            >登录</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogForget" width="540px">
      <div class="login_box">
        <div class="login_box-title">忘记密码</div>
        <div class="login_box-wrap">
          <div class="login_box-line">
            <el-input
              type="text"
              v-model="resetForm.mobile"
              placeholder="请输入手机号"
            ></el-input>
          </div>
          <div class="login_box-line">
            <el-input placeholder="请输入验证码" v-model="resetForm.code">
              <template v-if="can_get_code">
                <el-button type="primary" slot="suffix" @click="clickSendSms"
                  >获取验证码</el-button
                >
              </template>
              <template v-else>
                <el-button
                  type="primary"
                  disabled
                  slot="suffix"
                  @click="clickSendSms"
                  >{{ `${left_second}S` }}</el-button
                >
              </template>
            </el-input>
          </div>
          <div class="login_box-line">
            <el-input
              placeholder="请设置新密码"
              type="password"
              v-model="resetForm.password"
            ></el-input>
          </div>
          <div class="login_box-line">
            <el-input
              placeholder="请再次输入密码"
              type="password"
              v-model="resetForm.password_again"
            ></el-input>
          </div>
          <el-button
            style="margin:24px 0 0;width:100%;"
            type="primary"
            @click="clickResetBtn"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { fetchSendSms, fetchForgetPwd } from "@/api/user";
export default {
  name: "LayoutIndex",

  data() {
    return {
      loginForm: {
        mobile: "",
        password: ""
      },
      resetForm: {
        mobile: "",
        code: "",
        password: "",
        password_again: ""
      },
      dialogLogin: false,
      dialogForget: false,
      can_get_code: true,
      default_second: 5,
      left_second: 60
    };
  },
  mounted() {
    this.$bus.$on("show-login-box", () => {
      this.dialogLogin = true;
    });
  },
  methods: {
    ...mapActions("user", ["userLogin", "userInfo"]),
    ...mapMutations("user", ["resetUser"]),
    showForgetDialog() {
      this.dialogLogin = false;
      this.dialogForget = true;
    },
    showLoginDialog() {
      this.dialogLogin = true;
    },
    clickNavItem(type) {
      let toPath = "/home",
        currentPath = this.$route.path;

      switch (type) {
        case "home":
          toPath = "/home";
          break;
        case "train":
          toPath = "/train";
          break;
        case "exam":
          toPath = "/exam/list";
          break;
        default:
          break;
      }
      if (currentPath === toPath) {
        return;
      }

      if (toPath === "/exam/list" && !this.has_login) {
        this.showLoginDialog();
      } else {
        this.$router.push({
          path: toPath
        });
      }
    },
    clickLoginBtn() {
      const { loginForm } = this;
      const { mobile, password } = loginForm;
      if (!mobile) {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        });
        return;
      }
      if (!password) {
        this.$message({
          message: "请输入密码",
          type: "warning"
        });
        return;
      }
      this.userLogin(loginForm)
        .then((res) => {
          console.log(res);
          this.userInfo()
            .then((res1) => {
              console.log(res1);
              this.dialogLogin = false;
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    clickResetBtn() {
      const { resetForm } = this;
      const { mobile, code, password, password_again } = resetForm;
      if (!mobile) {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        });
        return;
      }
      if (!code) {
        this.$message({
          message: "请输入验证码",
          type: "warning"
        });
        return;
      }
      if (!password) {
        this.$message({
          message: "请输入新密码",
          type: "warning"
        });
        return;
      }
      if (!password_again) {
        this.$message({
          message: "请再次输入密码",
          type: "warning"
        });
        return;
      }
      if (password !== password_again) {
        this.$message({
          message: "两次密码不一致",
          type: "warning"
        });
        return;
      }
      fetchForgetPwd(resetForm)
        .then((res) => {
          const { code } = res;
          if (code === 200) {
            this.$message({
              message: "密码重置成功，请重新登录",
              type: "success"
            });
            this.resetUser();
            this.dialogForget = false;
          }
        })
        .catch(() => {});
    },
    clickSendSms() {
      const { resetForm } = this;
      const { mobile } = resetForm;
      if (!mobile) {
        this.$message({
          message: "请输入手机号",
          type: "warning"
        });
        return;
      }
      fetchSendSms({
        phone: mobile
      })
        .then(() => {
          this.can_get_code = false;
          this.left_second = this.default_second;
          this.timer = setInterval(() => {
            this.left_second = this.left_second - 1;
            if (this.left_second <= 0) {
              clearInterval(this.timer);
              this.can_get_code = true;
            }
          }, 1000);
        })
        .catch(() => {});
    }
  },
  computed: {
    ...mapState("user", ["has_login", "username", "avatar"]),
    key() {
      return this.$route.path;
    },
    activeNav() {
      const { meta } = this.$route;
      const { active } = meta;
      return active || "";
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
